import { render, staticRenderFns } from "./sendSMS.vue?vue&type=template&id=52d26f9e&scoped=true&"
import script from "./sendSMS.vue?vue&type=script&lang=js&"
export * from "./sendSMS.vue?vue&type=script&lang=js&"
import style0 from "./sendSMS.vue?vue&type=style&index=0&id=52d26f9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d26f9e",
  null
  
)

export default component.exports